import { UnavailableDataPlaceholderText } from "constants/text.ts";
import {
	getAckEmailCount,
	getAckPriceFormat
} from "pages/Preferences/Accounts/AccountBillToPage/utils/AccountBillToPage.utils.ts";
import { StyledTableCell } from "components/Common/Table/StyledTable.styles.ts";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { models } from "types/api/viewModels.ts";
import { ClickableTableRow } from "components/AdminSettings/AdminSearchTable.styles.ts";
import { useNavigate } from "react-router";

interface AccountBillToTableRowProps {
	billTo: models["BillToViewModel"];
}

export const AccountBillToTableRow = ({ billTo }: AccountBillToTableRowProps) => {
	const navigate = useNavigate();

	const billToCityState = [billTo.city, billTo.state].filter(Boolean).join(", ");
	const billToName =
		[billTo.projectName, billToCityState].filter(Boolean).join(" - ") || UnavailableDataPlaceholderText;

	const handleClick = () => {
		navigate(`/admin-settings/accounts/${billTo.accountId}/billTos/${billTo.billToId}`);
	};

	return (
		<ClickableTableRow
			data-testid={`billTo-${billTo?.billToId}`}
			onClick={handleClick}
		>
			<StyledTableCell
				data-testid="admin-billTos-table-name"
				maxWidth="240px"
			>
				{billToName}
			</StyledTableCell>

			<StyledTableCell
				data-testid="admin-billTos-table-number"
				minWidth="120px"
			>
				{billTo?.billToId ?? UnavailableDataPlaceholderText}
			</StyledTableCell>

			<StyledTableCell
				data-testid="admin-billTos-table-type"
				maxWidth="140px"
			>
				{getAckEmailCount(billTo) ?? UnavailableDataPlaceholderText}
			</StyledTableCell>

			<StyledTableCell
				data-testid="admin-billTos-table-email"
				maxWidth="140px"
			>
				{getAckPriceFormat(billTo) ?? UnavailableDataPlaceholderText}
			</StyledTableCell>

			<StyledTableCell
				fixedWidth="40px"
				isLastIndex
			>
				<ChevronRight />
			</StyledTableCell>
		</ClickableTableRow>
	);
};
